module.exports = __webpack_public_path__ + "static/media/status3.d4809b88.png";